import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useTranslate, useDataProvider } from 'react-admin';
import { Paper, Box, Button, InputBase, Typography } from '@material-ui/core';
import Checkbox from '../checkbox'
import { Search } from '@material-ui/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { parse } from 'date-fns';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    list: {
        maxHeight: 320,
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    paper: {
        display: 'flex',
        justifyItems: 'center',
        height: 400,
        boxShadow: 'none'
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
}));

const FilterInput = ({ onChangeValue, value, name }) => {
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    return (
        <Box width={234} mb={1} display='flex' borderRadius='8.1px' bgcolor='background.default'>
            <Search style={{ color: theme.palette.grey['300'], size: '18px', margin: 'auto 2px auto 5px' }} />
            <InputBase
                value={value}
                onChange={onChangeValue}
                placeholder={"Filter " + name}
                style={{ width: 180 }}
            />
        </Box>
    )
}



export default function TransferList({ setRight, assigns, setLeft, hiddenButton, readOnly, left, handleAddChannel, right, groups, setGroups }) {
    const translate = useTranslate()
    const classes = useStyles();
    const [checked, setChecked] = React.useState([]);
    const [filter, setFilter] = React.useState('')
    const [groupFilter, setGroupFilter] = React.useState('')
    const [groupsFilter, setGroupsFilter] = React.useState(groups.filter(value => right.findIndex(element => element.id === 'group-' + value.id) < 0
        && value.channels.filter(element => assigns.findIndex(item => item.id === element.id) > -1).length !== value.channels.length))
    const [leftsFilter, setLeftFilter] = React.useState(left.filter(value => right.findIndex(element => element.id === value.id) > 0
        && assigns.findIndex(element => element.id === value.id) < 0))
    // const dataProvider = useDataProvider()
    // const grid = 8;


    const onChangeFilter = (event) => {
        setFilter(event.target.value)
        setLeftFilter(left.filter(value => value.name.toUpperCase().search(event.target.value.toUpperCase()) > -1
            && right.findIndex(element => element.id === value.id) < 0 && assigns.findIndex(element => element.id === value.id) < 0))
    }

    const onChangeGroupFilter = (event) => {
        setGroupFilter(event.target.value)
        setGroupsFilter(groups.filter(value => value.name.toUpperCase().search(event.target.value.toUpperCase()) > -1
            && right.findIndex(element => element.id === 'group-' + value.id) < 0
            && value.channels.filter(element => assigns.findIndex(item => item.id === element.id) > -1).length !== value.channels.length))
    }

    useEffect(() => {
        setLeftFilter(left.filter(value => value.name.toUpperCase().search(filter.toUpperCase()) > -1
            && right.findIndex(element => element.id === value.id) < 0 && assigns.findIndex(element => element.id === value.id) < 0))
        setGroupsFilter(groups.filter(value => value.name.toUpperCase().search(groupFilter.toUpperCase()) > -1
            && right.findIndex(element => element.id === 'group-' + value.id) < 0
            && value.channels.filter(element => assigns.findIndex(item => item.id === element.id) > -1).length !== value.channels.length))
    }, [assigns])

    const handleToggle = (value, style) => () => {
        const temps = right.slice()
        const tempsfilters = leftsFilter.slice()
        const tempsGroupFilter = groupsFilter.slice()
        if (style === 'left') {
            setFilter('')
            const index = tempsfilters.findIndex(element => element.id === value.id);
            tempsfilters.splice(index, 1)
            setLeftFilter(tempsfilters)
            temps.push(value)
            setRight(temps)
            const newChecked = [...checked];
            newChecked.push(value);
            setChecked(newChecked);
        }
        else if (style === 'right') {
            const index = right.findIndex(element => element.id === value.id);
            temps.splice(index, 1)
            setRight(temps)
            if (value.id.toString().search('group') < 0) {
                tempsfilters.push(value)
                setLeftFilter(tempsfilters)
            }
            else {
                let tempValue = { ...value }
                tempValue.id = parseInt(tempValue.id.replace('group-', ''))
                tempsGroupFilter.push(tempValue)
                setGroupsFilter(tempsGroupFilter)
            }
            const newChecked = [...checked];
            newChecked.push(value);
            setChecked(newChecked);
        }
        else {
            setGroupFilter('')
            const index = groupsFilter.findIndex(element => element.id === value.id);
            tempsGroupFilter.splice(index, 1)
            setGroupsFilter(tempsGroupFilter)
            let tempValue = { ...value }
            tempValue.id = 'group-' + tempValue.id
            temps.push(tempValue)
            setRight(temps)
            const newChecked = [...checked];
            newChecked.push(value);
            setChecked(newChecked);
        }

    };


    // const onDragEnd = (result) => {
    //     const { source, destination } = result;
    //     console.log(result)
    //     if (!destination) {
    //         return;
    //     }
    //     if (source.droppableId === destination.droppableId) {

    //         const items = reorder(
    //             getList(source.droppableId),
    //             source.index,
    //             destination.index
    //         );

    //         if (source.droppableId === 'right') {
    //             setRight(items)
    //         }
    //         else {
    //             setLeftFilter(items)
    //         }


    //     } else {
    //         const result = move(
    //             getList(source.droppableId),
    //             getList(destination.droppableId),
    //             source,
    //             destination
    //         );
    //         if (destination.droppableId === 'group') {
    //             if (source.droppableId === 'right') {
    //                 result.group.map(item => {
    //                     item.id = parseInt(item.id.toString().replace('group-', ''))
    //                     return item
    //                 })
    //                 setGroupsFilter(result.group)
    //                 setRight(result.right)
    //             }
    //         }
    //         else if (source.droppableId === 'group') {
    //             if (destination.droppableId === 'right') {
    //                 result.group.map(item => {
    //                     item.id = 'group-' + item.id
    //                     return item
    //                 })
    //                 setGroupsFilter(result.group)
    //                 setRight(result.right)
    //             }
    //         }

    //         else {
    //             setLeftFilter(result.left)
    //             console.log(result)
    //             // if (destination.droppableId === 'left') {
    //             //     let temps = left.slice()
    //             //     temps.push(result.left[destination.index])
    //             //     setLeft(temps)
    //             // }

    //             setRight(result.right)
    //         }

    //     }

    // };

    // const getItemStyle = (isDragging, draggableStyle) => {
    //     return {
    //         // some basic styles to make the items look a bit nicer

    //         ...draggableStyle,
    //         padding: 0,
    //         ...(isDragging && {

    //             background: "rgb(235,235,235)"
    //         })

    //     }
    // }

    // const getListStyle = isDraggingOver => ({
    //     padding: 0,
    //     width: 250
    // });



    if (!left) return null



    const customList = (items, style) => {


        return (
            <Box >
                <Paper className={classes.paper}>
                    <Box width='100%'>
                        {style === 'left' &&
                            <Box p={1} display='flex' justifyContent='center'>
                                <FilterInput
                                    onChangeValue={onChangeFilter}
                                    value={filter}
                                    name={"channel"} />
                            </Box>
                        }
                        {style === 'group' &&
                            <Box p={1} display='flex' justifyContent='center'>
                                <FilterInput
                                    onChangeValue={onChangeGroupFilter}
                                    value={groupFilter}
                                    name={"group"} />
                            </Box>
                        }
                        <List className={classes.list} component="nav" disablePadding>
                            {items.map((item, index) => (

                                <ListItem
                                    key={item.id}
                                    onClick={handleToggle(item, style)}
                                    button
                                    ContainerComponent="li"
                                >
                                    <Checkbox
                                        checked={style === 'right'}

                                        color='primary'
                                    />
                                    <Typography variant='body1'>{item.name}</Typography>
                                    {
                                        item.id.toString().search('group-') !== -1 || style === 'group' ?
                                            <Typography variant='subtitle2' style={{ marginLeft: 8 }}>
                                                {
                                                    `(${item.channels.length + ` ${item.channels.length > 1 ?
                                                        'channels' : 'channel'}`})`
                                                }
                                            </Typography> : ''
                                    }

                                </ListItem>


                            ))}

                        </List>
                    </Box>

                </Paper>
            </Box >
        )

    };

    return (

        <Box>
            <Box display='flex' justifyContent='flex-start'>
                <Box mr={2} width={250}>
                    {customList(groupsFilter, 'group')}
                </Box>
                <Box mr={2} width={250}>
                    {customList(leftsFilter, 'left')}
                </Box>
                <Box width={250}>
                    {customList(right, 'right')}
                    {
                        !hiddenButton && (
                            <Box display='flex' justifyContent='flex-end' mt={1}>
                                <Button
                                    disabled={readOnly}
                                    variant="contained" color='primary' size='large' onClick={handleAddChannel}>
                                    {translate(`resources.room.add`)}
                                </Button>
                            </Box>
                        )
                    }

                </Box>

            </Box>
        </Box>
    );
}